<div class="rounded-3xl flex flex-row justify-start font-medium items-start" (click)="handleClick($event)" (keydown)="handleKeydown()" tabindex="0">
    <div>
        <lib-app-icon [icon]="getIconType()" [size]="'20x16'" className="icon-filled"/>
    </div>
    <div class="rounded-3xl flex flex-col flex-1 min-w-0 pl-2 text-sm font-medium leading-[20px] tracking-[0.1px]">
        <div class="flex items-center gap-[4px]" [class.hidden]="!this.getIsFromThirdPartySystem() && !getTourPointLabel()" i18n>
            @if (this.getIsFromThirdPartySystem()) {
                <div class="out-of-system max-w-[360px] w-full whitespace-normal break-words">
                    No further information is available for this tour point.
                </div>
            } @else {
                <span class="label grey-label"> {{getTourPointLabel()}}</span>
            }
        </div>
        @if (!this.getIsFromThirdPartySystem() && (tourPointConfig.customerTourNumber || tourPointConfig.loadingReference)) {
            <div class="flex items-center gap-x-1 min-w-0">
                @if (tourPointConfig.customerTourNumber) {
                    <span class="grey-label shrink-0" i18n>Tour:</span>
                    <span class="value truncate grow shrink-0 basis-[5ch] max-w-max" [title]="tourPointConfig.customerTourNumber">{{tourPointConfig.customerTourNumber}}</span>
                }
                @if (tourPointConfig.customerTourNumber && tourPointConfig.loadingReference) {
                    <span class="grey-label shrink-0">-</span>
                }
                @if (tourPointConfig.loadingReference) {
                    <span class="grey-label shrink-0" i18n>Booking:</span>
                    <span class="value truncate min-w-0" [title]="tourPointConfig.loadingReference">{{tourPointConfig.loadingReference}}</span>
                }
            </div>
        }
        @if(tourPointConfig.name) {
            <div class="value">
                {{tourPointConfig.name}}
            </div>
        }
        <div class="value">
            {{tourPointConfig.street}}
        </div>
        <div>
            {{tourPointConfig.country}}-{{tourPointConfig.postalCode}} {{tourPointConfig.city}}
        </div>
        
        <div class="flex max-w-[480px] flex-wrap mt-2">
            @for(chip of tourPointConfig.infoChips; track chip.name) {
                <cal-draggable-card-info-chip [chip]="chip" className="!border !border-solid tour-point-chip"/>
            }
        </div>
    </div>
</div>
